import "./loadingIconStyles.css";

const LoadingIcon = ({ large }: { large?: boolean }) => {
    return (
        <div className={`logo-container${large ? "-l" : ""}`}>
            <img
                src={`${window.location.origin}/assets/images/loaderLogo.webp`}
                alt="autobackorder"
                className={`logo-image${large ? "-l" : ""}`}
            />
            <div className={`animated-circle${large ? "-l" : ""}`}></div>
        </div>
    );
};

export default LoadingIcon;
